import React, { Component } from 'react';

class Home extends Component {

  render(){
    return (
      <div>
        <h1>This is the home view</h1>
        <h2>Will have more information here about the app</h2>
      </div>
    );
  };

};

export default Home;



// WEBPACK FOOTER //
// ./src/components/home/home.js